// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `This action is worth ${i.count} ${i.entries}`
};

const de_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Diese Aktion bringt dir ${i.count} ${i.entries}`
};

const es_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Esta acción vale ${i.count} ${i.entries}`
};

const fr_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Cette action vous donnera ${i.count} ${i.entries}`
};

const fi_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Tämä toiminto on ${i.count} ${i.entries} arvoinen`
};

const hi_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `यह कार्य ${i.count} ${i.entries} के बराबर है`
};

const ja_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `このアクションは${i.count}${i.entries}の価値があります`
};

const nl_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Deze actie is ${i.count} ${i.entries} waard`
};

const pt_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Esta ação vale ${i.count} ${i.entries}`
};

const ro_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Această acțiune valorează ${i.count} ${i.entries}`
};

const th_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `การดำเนินการนี้มีมูลค่า ${i.count} ${i.entries}`
};

const ur_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `یہ ایکشن ${i.count} ${i.entries} کے قابل ہے`
};

const zh_hant1_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `此操作價值 ${i.count} ${i.entries}`
};

const da_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Denne handling er værd ${i.count} ${i.entries}`
};

const it_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Questa azione vale ${i.count} ${i.entries}`
};

const vn_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Hành động này có giá trị ${i.count} ${i.entries}`
};

const ko_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `이 액션은 ${i.count}${i.entries}의 가치가 있습니다`
};

const tr_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Bu eylem ${i.count} ${i.entries} değerinde`
};

const lv_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Šī darbība ir vērta ${i.count} ${i.entries}`
};

const ar_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `هذا الإجراء يستحق ${i.count} ${i.entries}`
};

const bs_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Ova akcija vrijedi ${i.count} ${i.entries}`
};

const sl_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Ta akcija je vredna ${i.count} ${i.entries}`
};

const id_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Aksi ini bernilai ${i.count} ${i.entries}`
};

const sv_widget_action_worth = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Denna åtgärd är värd ${i.count} ${i.entries}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown>, entries: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_action_worth = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_action_worth(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_action_worth", locale)
	if (locale === "en") return en_widget_action_worth(inputs)
	if (locale === "de") return de_widget_action_worth(inputs)
	if (locale === "es") return es_widget_action_worth(inputs)
	if (locale === "fr") return fr_widget_action_worth(inputs)
	if (locale === "fi") return fi_widget_action_worth(inputs)
	if (locale === "hi") return hi_widget_action_worth(inputs)
	if (locale === "ja") return ja_widget_action_worth(inputs)
	if (locale === "nl") return nl_widget_action_worth(inputs)
	if (locale === "pt") return pt_widget_action_worth(inputs)
	if (locale === "ro") return ro_widget_action_worth(inputs)
	if (locale === "th") return th_widget_action_worth(inputs)
	if (locale === "ur") return ur_widget_action_worth(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_action_worth(inputs)
	if (locale === "da") return da_widget_action_worth(inputs)
	if (locale === "it") return it_widget_action_worth(inputs)
	if (locale === "vn") return vn_widget_action_worth(inputs)
	if (locale === "ko") return ko_widget_action_worth(inputs)
	if (locale === "tr") return tr_widget_action_worth(inputs)
	if (locale === "lv") return lv_widget_action_worth(inputs)
	if (locale === "ar") return ar_widget_action_worth(inputs)
	if (locale === "bs") return bs_widget_action_worth(inputs)
	if (locale === "sl") return sl_widget_action_worth(inputs)
	if (locale === "id") return id_widget_action_worth(inputs)
	if (locale === "sv") return sv_widget_action_worth(inputs)
	return "widget_action_worth"
};